var ctrlopt = ctrlopt,
  google = google,
  generic = generic || {},
  FB = FB || '',
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  var oab_time_override = oab.oab_override_time_format || 0;
  var oab_override_min_format = oab.oab_override_min_format || 0;
  var oab_date_format = settings.oab_date_format || 0;
  var oab_email_required_err_msg = settings.oab_email_required_err_msg || 0;
  var oab_error_password_required = settings.oab_error_password_required || 0;
  var oab_send_sms_default = oab.oab_send_sms_default || 0;
  var oab_do_not_display_ordinal_for_date = oab.oab_do_not_display_ordinal_for_date || 0;
  var oab_town_postcode_format = oab.oab_town_postcode_format || '';
  var ommit_sms = oab.ommit_sms || 0;
  var phone_code_multiple_prefix = oab.phone_code_multiple_prefix || 0;
  var appointment_booking_show_mobile_prefix = oab.appointment_booking_show_mobile_prefix || 0;
  var jsconfig_settings = Drupal.settings.global_variables || {};
  var is_coresite = oab.coresite || 0;
  var phone1Input, phone2Input, apptKRPhoneCode, apptKrSelectPhoneCode;
  var oab_sms_reservation = oab.oab_sms_reservation || 0;
  var is_pc_email_promotions_required = oab.pc_email_promotions_required || 0;

  function getNumberWithOrdinal(dayNumber) {
    var termination = ['th', 'st', 'nd', 'rd'],
      v = dayNumber % 100;

    return dayNumber + (termination[(v - 20) % 10] || termination[v] || termination[0]);
  }

  /* Concrete View */
  apptBook.AppointmentReviewConfirm = function (container) {
    apptBook.AppointmentReviewConfirm.superclass.constructor.call(this);
    this.id = 'review';
    this.initialized = false;
    this.jqBod = $('body');
    this.container = container;
    this.apptBookSections = this.jqBod.find('.js-appointment-book-sections');
    this.currencySymbol = this.apptBookSections.data('currency-symbol');
    this.servContainer = container.find('.js-review-book-services');
    this.serviceTmpl = this.servContainer.find('.js-review-book-service').remove();
    this.changeServices = container.find('.js-edit-services-link');
    this.changeLocation = container.find('.js-edit-location-link');
    this.changeDateTime = container.find('.js-edit-date-time-link');
    this.locationContainer = container.find('.js-review-book-location');
    this.dateTimeContainer = container.find('.js-review-book-date-time');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.amLabel = this.container.attr('data-am-label');
    this.pmLabel = this.container.attr('data-pm-label');
    this.displayAMPM = this.container.attr('data-am-pm-display');
    this.dateFormat = this.container.attr('data-date-format');
    this.yearSuffix = this.container.attr('data-year-suffix');
    this.daySuffix = this.container.attr('data-day-suffix');
    this.monthSuffix = this.container.attr('data-month-suffix');
    this.days = this.container.attr('data-day-names').split(',');
    this.months = this.container.attr('data-month-names').split(',');
    this.timeFormatSuffix = this.container.attr('data-time-format-suffix');
    this.locSelect = container.find('select.location-select');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.artAnyValue = this.artSelect.attr('data-artist-any-value');
    this.signInContainer = container.find('.js-appt-book-sign-in-container');
    this.bookContainer = container.find('.js-book-appt-container');
    this.confContainer = container.find('.js-confirm-container');
    this.totalElem = this.confContainer.find('.js-total-time');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.js-start-over');
    this.selErrOverlay = container.find('.js-appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.js-appt-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.serviceIds = [];
    this.stores = {};
    this.updateMode = false;
    this.map = null;
    this.mapZoomLevel = 13;
    this.signUpEmailDone = false;
  };

  ctrlopt.extend(apptBook.AppointmentReviewConfirm, apptBook.AbstractSection);

  apptBook.AppointmentReviewConfirm.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';

    this.serviceIds = [];
    this.totalTime = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildServices();
        me.buildVirtualReview();
        me.buildDateTime();
        me.buildArtists();
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointment_id) {
        me.model.getAppointment(
          data.params.appointment_id,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = data.params.counter_id;
            me.calendarId = data.params.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.startTime = data.params.start_time;
            servs = data.params.services;
            var virtual = apptData.virtual_meeting_link ? 1 : 0;

            localStorage.setItem('virtual_oab', virtual);
            for (var i = 0, len = servs.length; i < len; i += 1) {
              var servId;

              servObj = servs[i];
              me.servicesData.push({
                serviceId: servObj.serviceId || servObj.id,
                serviceDuration: servObj.serviceDuration || servObj.total_duration,
                serviceName: servObj.serviceName || servObj.name,
                serviceDescription: servObj.serviceDescription || servObj.description,
                servicePicture: servObj.servicePicture || servObj.picture,
                servicePrice: servObj.servicePrice || servObj.price
              });
              servId = servObj.serviceId || servObj.id;
              me.serviceIds.push(servId);
            }

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        me.calendarId = data.params.calendar_id;
        if (me.counterId !== data.params.counter_id) {
          me.calendarId = '0';
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counter_id;
        me.startTime = data.params.start_time;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function () {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentReviewConfirm.prototype.buildServices = function () {
    var myTmpl,
      sData,
      servicePriceVal = '0',
      $servImg,
      me = this,
      price,
      oab_price_decimal = oab.oab_price_decimal,
      oab_currency_position = oab.oab_currency_position;

    this.servContainer.find('.js-review-book-service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      $servImg = $('<img/>');
      sData = this.servicesData[i];
      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);
      $servImg.attr('data-src', sData.servicePicture);
      $servImg.addClass('lazyload');

      servicePriceVal = oab_price_decimal
        ? parseInt(sData.servicePrice).toFixed(oab_price_decimal)
        : sData.servicePrice;
      price =
        oab_currency_position === 'suffix'
          ? servicePriceVal + ' ' + this.currencySymbol
          : this.currencySymbol + ' ' + servicePriceVal;

      myTmpl.find('.js-service-picture').append($servImg);
      myTmpl.find('.js-service-name').text(sData.serviceName);
      myTmpl.find('.js-service-description').text(sData.serviceDescription);
      myTmpl.find('.js-service-duration').text(sData.serviceDuration + ' ' + this.minLabel);
      if (servicePriceVal) {
        myTmpl.find('.js-service-price').text(price);
      }
      this.totalTime += parseInt(sData.serviceDuration);
      this.changeServices.off('click');
      this.changeServices.click(changeServSel);
    }

    function changeServSel(e) {
      e.preventDefault();
      var upObj = {};

      upObj = {
        sectionId: 'services',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          serviceIds: me.serviceIds,
          updateMode: me.updateMode
        }
      };
      me.model.update(upObj);
    }
  };
  apptBook.AppointmentReviewConfirm.prototype.buildLocationMap = function () {
    var center;
    var me = this,
      mapOptions = {},
      $bookStoreMap = this.container.find('#appt_book_store_map'),
      $bookStoreMapContainer = this.container.find('.js-appt_book_store_map_container'),
      door = me.counterData,
      locLat = door.counter_lat,
      locLng = door.counter_lng;

    center = new google.maps.LatLng(locLat, locLng);

    if (this.map) {
      this.map.setCenter(center);
      this.map.setZoom(this.mapZoomLevel);
    } else {
      mapOptions = {
        zoom: this.mapZoomLevel,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: false
      };
      $bookStoreMapContainer.show();
      this.map = new google.maps.Map($bookStoreMap[0], mapOptions);
    }
    addMarket(door, this);

    function addMarket(door, me) {
      var map = me.map;
      var latLng = new google.maps.LatLng(door.counter_lat, door.counter_lng);
      var marker = new google.maps.Marker({
        position: latLng,
        map: map,
        door: door,
        me: me
      });

      marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 1);
      door.marker = marker;
    }
  };
  apptBook.AppointmentReviewConfirm.prototype.buildLocation = function () {
    var me = this,
      $phoneNodeLink,
      storeName = me.counterData.name,
      address1 = me.counterData.address1,
      address2 = me.counterData.address2,
      town = me.counterData.town,
      postCode = me.counterData.postcode,
      phone = me.counterData.phone,
      $storeNameNode = this.locationContainer.find('.js-review-location-name'),
      $address1Node = this.locationContainer.find('.js-review-location-address1'),
      $address2Node = this.locationContainer.find('.js-review-location-address2'),
      $townPostCodeNode = this.locationContainer.find('.js-review-location-town-postcode'),
      $phoneNode = this.locationContainer.find('.js-review-location-phone').empty();

    $phoneNodeLink = $('<a>', {
      text: phone,
      href: 'tel:' + phone,
      target: '_blank'
    });

    $storeNameNode.html(storeName);
    $address1Node.html(address1);
    $address2Node.html(address2);
    if (!oab_town_postcode_format) {
      $townPostCodeNode.html(postCode + ' ' + town);
    } else {
      $townPostCodeNode.html(
        oab_town_postcode_format.replace('[town]', town).replace('[postcode]', postCode)
      );
    }
    $phoneNode.append($phoneNodeLink);

    function changeLocationSelect(e) {
      e.preventDefault();
      var upObj = {};
      var headerDiv = $('.js-appt-book-header-content');
      var imageHeight = headerDiv.css('height');

      upObj = {
        sectionId: 'counters',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };
      me.model.update(upObj);
      // update the banner height after change location click event
      headerDiv.css('height', imageHeight);
    }

    this.changeLocation.off('click');
    this.changeLocation.click(changeLocationSelect);
  };

  apptBook.AppointmentReviewConfirm.prototype.buildDateTime = function () {
    var m,
      d,
      y,
      h,
      hMod,
      hModMin,
      hMin,
      minVal,
      hSuffix,
      apptDayStr,
      min,
      dayName,
      me = this,
      apptDate = this.convertTimeString(me.startTime),
      $dateTimeDay = me.dateTimeContainer.find('.js-date-time-day'),
      $dateTimeHour = me.dateTimeContainer.find('.js-date-time-hour'),
      oab_time_separator = oab.oab_time_separator || ':';

    m = this.months[apptDate.getMonth()];
    d = apptDate.getDate();
    y = apptDate.getFullYear();
    h = apptDate.getHours();
    min = apptDate.getMinutes();
    dayName = this.days[apptDate.getDay()];

    if (this.displayAMPM === '1') {
      hSuffix = h < 12 ? this.amLabel : this.pmLabel;
      hMin = h;
      hMod = ((h + 11) % 12) + 1;
      hModMin = hMod;
      if (oab_override_min_format) {
        minVal = min === 0 ? '00' : min;
        hMin = h + ':' + minVal;
        hModMin = hMod + ':' + minVal;
      } else if (!oab_override_min_format && min !== 0) {
        hMin = h + ':' + min;
        hModMin = hMod + ':' + min;
      }
      h = (oab_time_override ? hMin : hModMin) + ' ' + hSuffix;
    } else {
      h = h + oab_time_separator + (min === 0 ? '00' : min) + this.timeFormatSuffix;
    }
    if (!oab_do_not_display_ordinal_for_date) {
      d = getNumberWithOrdinal(d);
    }
    if (oab_date_format) {
      apptDayStr =
        y +
        ' ' +
        this.yearSuffix +
        ' ' +
        (apptDate.getMonth() + 1) +
        ' ' +
        this.monthSuffix +
        ' ' +
        d +
        ' ' +
        this.daySuffix;
    } else {
      apptDayStr = this.dateFormat
        .replace(/\bd\b/, d)
        .replace(/\bm\b/, m)
        .replace(/\by\b/, y)
        .replace(/\bdayName\b/, dayName);
    }

    $dateTimeDay.text(apptDayStr);
    $dateTimeHour.text(h);

    function changeDateTimeSelect(e) {
      e.preventDefault();
      var upObj = {};

      upObj = {
        sectionId: 'appointments',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          calendarId: me.calendarId,
          serviceIds: me.serviceIds,
          services: me.servicesData,
          appointmentId: me.appointmentId,
          startTime: me.startTime,
          updateMode: me.updateMode
        }
      };
      me.model.update(upObj);
    }

    this.changeDateTime.off('click');
    this.changeDateTime.click(changeDateTimeSelect);
  };

  apptBook.AppointmentReviewConfirm.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };
  apptBook.AppointmentReviewConfirm.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    this.artContainer.show();
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      this.artContainer.hide();
    } else if (calData.length <= 1) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        if (calData[i].public_name === 'Any' && this.artAnyValue) {
          calData[i].public_name = this.artAnyValue;
        }
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

        if (optionValue === this.calendarId) {
          newOption.attr('selected', 'selected');
        }

        this.artSelect.append(newOption);
      }

      site.util.refreshSelectBoxes(me.container.find('.selectbox'));
    }
  };

  apptBook.AppointmentReviewConfirm.prototype.buildBookAppt = function () {
    var totText,
      area_code,
      me = this,
      signIn = this.signInContainer.find('.js-appt-book-sign-in-form-container'),
      signInLink = this.signInContainer.find('.js-appt-book-sign-in-link').off('click'),
      forgotPassword = this.signInContainer.find('.js-forgot-password'),
      loginEmail = this.signInContainer.find('.js-appt-book-login-email'),
      pw = this.signInContainer.find('.js-appt-book-login-password'),
      signInBtn = signIn.find('.js-appt-book-login-submit').off('click'),
      fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
      fbOverlay = signIn.find('.js-fb-disclaimer-error'),
      bookBtn = this.confContainer.find('.js-appt-book-submit').off('click'),
      fNameInput = this.bookContainer.find('.js-appt-book-first-name'),
      lNameInput = this.bookContainer.find('.js-appt-book-last-name'),
      emailInput = this.bookContainer.find('.js-appt-book-email'),
      phoneInput = this.bookContainer.find('.js-appt-book-mobile'),
      phonePrefixInput = this.bookContainer.find('.appt-book-mobile-prefix'),
      krFormat = this.bookContainer.find('.js_appt_use_kr_mobile_number_fields'),
      commentsInput = this.bookContainer.find('.js-appt-book-note'),
      signUpEmailInput = this.bookContainer.find('.js-registration-email-list').find('input'),
      signUpSMSInput = this.bookContainer.find('.js-registration-sms-list').find('input'),
      signUpApptSMSNotificationsEnabledInput = this.bookContainer
        .find('.js-enable_sms_notifications')
        .find('input'),
      errorContainer = this.container.find('.js-appt-book-confirm-error-messages'),
      errorMessages = errorContainer.find('.error-message'),
      termsPrivacyRadio = this.bookContainer.find('.js-appt-book-oab-legal-privacy'),
      smsBookingConfirmationRadio = this.bookContainer.find('.js-appt-book-oab-sms-confirmation'),
      termsEmailPromotionsRadio = this.bookContainer.find('.js-appt-book-oab-email-promotions'),
      termsSMSPromotionsRadio = this.bookContainer.find('.js-appt-book-oab-sms-notification'),
      termsPostalRadio = this.bookContainer.find('.js-appt-book-oab-postal'),
      termsPrivacyRadioLabel = this.bookContainer.find('.js-accept-terms-head'),
      smsBookingConfirmationRadioLabel = this.bookContainer.find(
        '.js-accept-sms-confirmation-head'
      ),
      termsAcceptPrivacyHead = this.bookContainer.find('.js-signup__accept-privacy-head'),
      termsEmailPromotionsRadioLabel = this.bookContainer.find('.js-accept-email-head'),
      termsSMSPromotionsRadioLabel = this.bookContainer.find('.js-accept-sms-head'),
      termsPostalRadioLabel = this.bookContainer.find('.js-accept-postal-head'),
      countryCode = this.bookContainer.find('.js-country-code'),
      drupal = Drupal || {},
      settings = drupal.settings || {},
      termsCheckbox = this.bookContainer.find('.js-appt-book-terms'),
      termsCommercialCheckbox = this.bookContainer.find('.appt-book-terms-commercial'),
      privacyCheckbox = this.bookContainer.find('.js-appt-book-oab-email-promotions'),
      termsCheckboxLabel = this.bookContainer.find('.js-registration-terms'),
      termsCommercialCheckboxLabel = this.bookContainer.find('.registration__terms_commercial'),
      privacyCheckboxLabel = this.bookContainer.find('.js-registration-oab-email-promotions'),
      mobilePrefixInput = this.bookContainer.find('input[name="mobile-prefix"]'),
      apptPhoneCode,
      apptPhoneCodeSplit,
      codeOptions,
      sms_enabled = this.bookContainer.data('enableSms')
        ? this.bookContainer.data('enableSms')
        : oab_send_sms_default,
      oab_default_checkbox_required = settings.oab_default_checkbox_not_required ? 0 : 1,
      apptMultiplePrefix = this.bookContainer.find('select.js-phone-multiple-prefix-select'),
      populateMobilePhoneWithPrefix,
      mobileParts;
    var apptUseKRMobileNumberFields = parseInt(krFormat.text());

    if (apptUseKRMobileNumberFields) {
      phone1Input = this.bookContainer.find('.js-appt-mobile-part1');
      phone2Input = this.bookContainer.find('.js-appt-mobile-part2');
      apptKRPhoneCode = this.bookContainer.find('.js-appt-kr-phone-code');
      apptPhoneCode = this.bookContainer.find('.js-appt-phone-codes');
      apptPhoneCode = apptPhoneCode.length ? apptPhoneCode.text() : '';
      apptKrSelectPhoneCode = this.bookContainer.find('select.js-appt-kr-phone-code');
      apptPhoneCodeSplit = apptPhoneCode.length ? apptPhoneCode.split(',') : '';

      $.each(apptPhoneCodeSplit, function (i, val) {
        codeOptions = $('<option></option>', {
          value: val,
          text: val
        });
        apptKRPhoneCode.append(codeOptions);
      });
      phoneInput.keydown(function (e) {
        var key = e.charCode || e.keyCode || 0;

        return (
          key === 8 ||
          key === 9 ||
          key === 46 ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105)
        );
      });
    }

    populateMobilePhoneWithPrefix = function (mobilePhone) {
      mobileParts = /^(\d+)-(\d*)$/gu.exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2]) {
        apptMultiplePrefix.val(mobileParts[1]);
        phoneInput.val(mobileParts[2]);
      }
    };

    if (settings.fb_login_app_id && site.facebook) {
      site.facebook.init();
    }

    this.startOver.off('click');
    this.startOver.click(function () {});

    loginEmail.val('');
    pw.val('');
    emailInput.val('').removeAttr('disabled');
    commentsInput.val('');
    this.totalElem.empty();

    if (phone_code_multiple_prefix) {
      apptPhoneCode = this.bookContainer.find('.js-phone-multiple-prefix');
      apptPhoneCode = apptPhoneCode.length ? apptPhoneCode.text() : '';

      $(apptMultiplePrefix).empty();
      apptPhoneCodeSplit = apptPhoneCode.length ? apptPhoneCode.split(',') : '';
      $.each(apptPhoneCodeSplit, function (i, val) {
        codeOptions = $('<option></option>', {
          value: val,
          text: val
        });
        apptMultiplePrefix.append(codeOptions);
      });
    }

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');
      $('.appointment-booking-review__account-signup-head').hide();

      bookBtn.removeClass('disabled');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name);
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name);
      }

      emailInput.val(this.userData.email_address).attr('disabled', 'disabled');

      if (this.userData.mobile_phone) {
        if (phone_code_multiple_prefix) {
          populateMobilePhoneWithPrefix(this.userData.mobile_phone);
        } else {
          phoneInput.val(this.userData.mobile_phone);
        }
      }

      if (oab_default_checkbox_required) {
        if (site.client.isMobile) {
          if (this.userData.mobile_email_optin || this.userData.pc_email_optin) {
            signUpEmailInput.attr('checked', 'checked');
          } else {
            signUpEmailInput.removeAttr('checked');
          }
        } else if (this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      }

      if (this.userData.sms_optin) {
        signUpSMSInput.attr('checked', 'checked');
      } else {
        signUpSMSInput.removeAttr('checked');
      }
    } else {
      this.signInContainer.css('display', 'block');
    }

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    this.totalElem.html(totText);

    $.each(['show', 'hide'], function (i, ev) {
      var el = $.fn[ev];

      $.fn[ev] = function () {
        this.trigger(ev);

        return el.apply(this, arguments);
      };
    });

    $('body').on('show', fbOverlay, function () {
      signIn.css('height', 'auto');
    });

    signInLink.click(function (e) {
      e.preventDefault();
      var h;

      $(this).css('display', 'none');

      signIn.css('display', 'block');
      signIn.css('height', 'auto');
      h = signIn.height();
      signIn.height(0);
      signIn.animate({ height: h }, 1000, function () {
        setSignIn();
      });
    });
    window.fbsignInBtn = fbsignInBtn;

    forgotPassword.click(function (e) {
      e.preventDefault();
      if (!loginEmail.val()) {
        return null;
      }
      site.signin.requestPassword(loginEmail.val());
    });

    function setSignIn() {
      fbsignInBtn.click(function () {
        var token = null,
          $this = $(this),
          params = [],
          lastSource = null,
          pcEmailPromotions = 0,
          $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }

        lastSource = 'appointment_booking';
        pcEmailPromotions = $optInFormInput.is(':checked') ? 1 : 0;

        if (typeof FB === 'object') {
          FB.getLoginStatus(function (response) {
            statusChangeCallback(response);
          });
        }

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }

        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: lastSource,
            PC_EMAIL_PROMOTIONS: pcEmailPromotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              var h,
                rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function () {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).attr('disabled', 'disabled');

                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                }
                if (rData.mobile_number) {
                  phoneInput.val(rData.mobile_number);
                }
                if (rData.mobile_phone) {
                  if (phone_code_multiple_prefix) {
                    populateMobilePhoneWithPrefix(rData.mobile_phone);
                  } else {
                    phoneInput.val(rData.mobile_phone);
                  }
                }
                if (site.client.isMobile) {
                  if (rData.mobile_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                } else {
                  if (rData.pc_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                }
                if (rData.sms_optin) {
                  signUpSMSInput.attr('checked', 'checked');
                } else {
                  signUpSMSInput.removeAttr('checked');
                }

                fNameInput.focus();

                me.userData = rData;
              });

              errorContainer.css('display', 'none');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.css('display', 'inline-block');
              bookBtn.removeClass('disabled');
              bookBtn.show();

              h = signIn.css('height');
              signIn.animate({ height: 0 }, 1000, function () {
                signIn.css('display', 'none');
                signIn.height(h);
                me.signInContainer.css('display', 'none');
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              var errorLookupFunc = {
                errorRequiredPassword: function () {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                },
                errorRequiredLoginId: function () {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                },
                errorSignInNoAccount: function () {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                },
                errorAccountLock: function () {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                },
                errorFacebookLogin: function (myErr) {
                  errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                }
              };
              var errorLookup = {
                'required.password.signin': {
                  showError: errorLookupFunc.errorRequiredPassword
                },
                'invalid.password.signin': {
                  showError: errorLookupFunc.errorRequiredPassword
                },
                'required_or.email_address.device_id.required_or.signin': {
                  showError: errorLookupFunc.errorRequiredLoginId
                },
                'invalid.email_address.signin': {
                  showError: errorLookupFunc.errorRequiredLoginId
                },
                'no_account..signin': {
                  showError: errorLookupFunc.errorSignInNoAccount
                },
                social_fb_no_email: {
                  showError: errorLookupFunc.errorFacebookLogin
                },
                social_duplicate_account_links: {
                  showError: errorLookupFunc.errorFacebookLogin
                }
              };

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key && errorLookup[myErr.key]) {
                  errorLookup[myErr.key].showError(myErr);
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });
      signInBtn.click(function (e) {
        e.preventDefault();
        var $this = $(this),
          params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function (jsonRpcResponse) {
            var h,
              rData = jsonRpcResponse.getData().userinfo;

            $('.appointment-booking-review__account-signup-head').hide();
            me.model.updateAuthToken(function () {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).attr('disabled', 'disabled');

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
              }
              if (rData.mobile_number) {
                phoneInput.val(rData.mobile_number);
              }
              if (rData.mobile_phone) {
                if (phone_code_multiple_prefix) {
                  populateMobilePhoneWithPrefix(rData.mobile_phone);
                } else {
                  phoneInput.val(rData.mobile_phone);
                }
              }
              if (site.client.isMobile) {
                if (rData.mobile_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              } else {
                if (rData.pc_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              }

              if (rData.sms_optin) {
                signUpSMSInput.attr('checked', 'checked');
              } else {
                signUpSMSInput.removeAttr('checked');
              }

              fNameInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');

            signInLink.css('display', 'inline-block');
            bookBtn.removeClass('disabled');
            bookBtn.css('display', 'inline-block');

            h = signIn.css('height');
            signIn.animate({ height: 0 }, 1000, function () {
              signIn.css('display', 'none');
              signIn.height(h);
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (oab_error_password_required) {
                  if (myErr.key === 'required.password.signin') {
                    pw.addClass('error');
                    errorMessages.filter('#error-required-password').css('display', 'block');
                  }
                } else {
                  if (myErr.key === 'required.password.signin') {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }
                }
                if (oab_email_required_err_msg) {
                  if (myErr.key === 'required.email_address.signin') {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }
                }
                if (myErr.key === 'format.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                }
                if (myErr.key === 'invalid.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'required_or.email_address.device_id.required_or.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'invalid.email_address.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
          }
        });
      });
    }

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        signUpEmailParams = [],
        signUpEmailObj = {},
        fName = fNameInput.val(),
        lName = lNameInput.val(),
        email = emailInput.val(),
        phone = phoneInput.val(),
        terms = termsCheckbox.is(':checked') ? 1 : 0,
        commercialTerms = termsCommercialCheckbox.is(':checked') ? 1 : 0,
        oab_email_promotions = privacyCheckbox.is(':checked') ? 400 : 0,
        signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
        signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
        enableApptSMS = signUpApptSMSNotificationsEnabledInput.is(':checked')
          ? signUpApptSMSNotificationsEnabledInput.val()
          : 0,
        oabTermsEmailPromotionsRadio = termsEmailPromotionsRadio.is(':checked')
          ? $('input[name=PC_EMAIL_PROMOTIONS]:checked').val()
          : 0,
        oabTermsSMSPromotionsRadio = termsSMSPromotionsRadio.is(':checked')
          ? $('input[name=APPT_SMS_NOTIFICATIONS]:checked').val()
          : 0,
        oabTermsPostalRadio = termsPostalRadio.is(':checked')
          ? $('input[name=POSTAL_PROMOTIONS]:checked').val()
          : 0,
        comments = commentsInput.val(),
        $this = $(this),
        mobilePrefix = mobilePrefixInput.val(),
        isEmptyField = 0,
        oabSMSOptin = $('input[name=APPT_SMS_NOTIFICATIONS]'),
        requireTermsForSMS = oabSMSOptin.length ? 1 : 0,
        oabSMSOptinValue;

      if ($this.hasClass('disabled')) {
        return;
      }
      errorContainer.css('display', 'block');
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle, label').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        $this.removeClass('disabled');

        return;
      }
      $this.addClass('disabled');

      params = {
        _TOKEN: '',
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.startTime,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email
      };
      if (requireTermsForSMS) {
        if (oabSMSOptin.attr('type') === 'checkbox') {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? 1 : 0;
        } else {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? oabSMSOptin.filter(':checked').val() : 0;
        }
      }
      if (enableApptSMS || sms_enabled) {
        if (requireTermsForSMS && parseInt(oabSMSOptinValue)) {
          params.sms_notifications_enabled = 1;
        } else if (requireTermsForSMS && !parseInt(oabSMSOptinValue)) {
          params.sms_notifications_enabled = 0;
        } else {
          params.sms_notifications_enabled = 1;
        }
      }
      // BB KR SMS reservation
      if (oab_sms_reservation) {
        params.sms_notifications_enabled = $('input[name=APPT_SMS_RESERVATION]:checked').val() || 0;
      }

      if (comments) {
        params.customer_comments = comments;
      }

      if (phone) {
        if (apptUseKRMobileNumberFields) {
          area_code = apptKrSelectPhoneCode.val();
          if (area_code) {
            area_code = area_code.substr(1, 2);
          }
          params.customer_phone =
            countryCode.text() + area_code + phone1Input.val() + phone2Input.val();
        } else {
          // making sure we pass phone number stripped from any dashes, brackets and leading zeros
          params.customer_phone = phone.replace(/\(|\)|-/gi, '');
          params.customer_phone = params.customer_phone.replace(/^(0)(\d+)$/, '$2');
          if (appointment_booking_show_mobile_prefix) {
            params.customer_phone =
              countryCode.text() + phonePrefixInput.val() + params.customer_phone;
          } else {
            params.customer_phone = countryCode.text() + params.customer_phone;
          }
        }
      }
      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_regex = new RegExp(phoneInput.attr('pattern'));
        var phone_prefix_regex = new RegExp(mobilePrefixInput.attr('pattern'));
        var phone1_regex, phone2_regex, phone_full_length, phone_zero_length_regex;

        if (apptUseKRMobileNumberFields) {
          phone1_regex = new RegExp(phone1Input.attr('pattern'));
          phone2_regex = new RegExp(phone2Input.attr('pattern'));
          phone_full_length = phone1Input.val() + phone2Input.val();
          phone_zero_length_regex = /^(?!0+$)\d{7,8}$/;
        }
        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!$(lNameInput.parent().parent()).hasClass('js-no-last-name') && !lNameInput.val()) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (termsCheckbox.val() && !termsCheckbox.is(':checked')) {
          errorMessages.filter('#error-terms').css('display', 'block');
          termsCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (termsCommercialCheckbox.val() && !termsCommercialCheckbox.is(':checked')) {
          errorMessages.filter('#error-terms-commercial').css('display', 'block');
          termsCommercialCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (privacyCheckbox.val() && !privacyCheckbox.is(':checked')) {
          errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
          privacyCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        // Make PC email opt-in checkbox required when `is_pc_email_promotions_required` locale flag is enabled.
        // This fixes locales for which Perlgem's email_signup form requires explicit marketing consent whenever an email address is submitted.
        // Enforcing validation client-side, so the customer sees a highlighted field instead of a silent server rejection.
        if (
          is_pc_email_promotions_required &&
          oab.oab_params &&
          signUpEmailInput.length &&
          !signUpEmailInput.is(':checked')
        ) {
          errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
          signUpEmailInput.closest('.js-registration-email-list').addClass('error');
          isEmptyField = 1;
        }
        if (jsconfig_settings.oab_legal_statement) {
          if (!termsPrivacyRadio.is(':checked')) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else if (
            termsPrivacyRadio.is(':checked') &&
            $('input[name=ACCEPTED_PRIVACY_POLICY]:checked').val() === '0'
          ) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPrivacyRadioLabel.removeClass('error');
          }
          if (smsBookingConfirmationRadio.length && !smsBookingConfirmationRadio.is(':checked')) {
            errorMessages.filter('#error-oab-sms-confirmation').css('display', 'block');
            smsBookingConfirmationRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            smsBookingConfirmationRadioLabel.removeClass('error');
          }
          if (termsEmailPromotionsRadio.length && !termsEmailPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsEmailPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsEmailPromotionsRadioLabel.removeClass('error');
          }
          if (termsSMSPromotionsRadio.length && !termsSMSPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsSMSPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSPromotionsRadioLabel.removeClass('error');
          }
          if (termsPostalRadio.length && !termsPostalRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsPostalRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPostalRadioLabel.removeClass('error');
          }
          if (
            (termsEmailPromotionsRadio.length && !termsEmailPromotionsRadio.is(':checked')) ||
            (termsPostalRadio.length && !termsPostalRadio.is(':checked'))
          ) {
            termsAcceptPrivacyHead.addClass('error');
          } else {
            termsAcceptPrivacyHead.removeClass('error');
          }
        }
        if (apptUseKRMobileNumberFields) {
          if (phone_full_length && !phone_zero_length_regex.test(phone_full_length)) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (!apptKrSelectPhoneCode.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          } else {
            apptKRPhoneCode.removeClass('error');
          }
          if (phone1Input.val()) {
            if (phone1_regex && !phone1_regex.test(phone1Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone1Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (phone2Input.val()) {
            if (phone2_regex && !phone2_regex.test(phone2Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone2Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
        } else {
          if (!phoneInput.val()) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          } else if (phone_regex && !phone_regex.test(phone)) {
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
            isEmptyField = 1;
          }
        }
        if (Drupal.settings.enable_mobile_prefix_validation) {
          if (!mobilePrefixInput.val()) {
            errorMessages.filter('#error-book-phone-prefix').css('display', 'block');
            mobilePrefixInput.addClass('error');
            isEmptyField = 1;
          } else if (phone_prefix_regex && !phone_prefix_regex.test(mobilePrefix)) {
            mobilePrefixInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-book-phone-prefix-invalid').css('display', 'block');
            isEmptyField = 1;
          }
        }
      }
      function onBookSuccess(r) {
        var updateData;

        if (site.track && typeof site.track.evtView === 'function') {
          site.track.evtView({
            page_url: '/book-appointment/complete',
            location: location.origin + '/book-appointment/complete',
            page_name: 'Book Appointment - Complete'
          });

          site.track.evtLink({
            event_name: 'appointmentBooking_complete',
            event_category: 'appointment booking',
            event_action: 'appointment booked',
            event_label: r.counter.store_no + ' - ' + r.counter.name + ' - ' + r.start_time
          });
        }
        // We need to pass some additional data down since the last appointment booked does not have all the data we need
        // to display on the confirmation page
        r.friendServiceData = this.friendServiceData;
        r.selfServiceData = this.selfServiceData;
        r.firstStartTime = this.firstStartTime;

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input').removeClass('error');
        me.container.find('textarea').removeClass('error');
        me.container.find('label').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
          errLName = r.customer_last_name,
          errEmail = r.customer_email,
          errPhone = r.customer_phone,
          errComments = r.customer_comments;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
        }
        if (errComments && errComments.length) {
          errorMessages.filter('#error-book-comments').css('display', 'block');
          commentsInput.addClass('error');
        }
      }

      function doBooking() {
        errorMessages.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle, label').removeClass('error');
        if (isEmptyField) {
          $this.removeClass('disabled');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          me.model.bookAppointment(params, onBookSuccess, onBookError);
        }
      }

      signUpEmailObj._SUBMIT = 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      signUpEmailObj.LAST_SOURCE = 'appointment_booking_reg';
      if (!signUpEmail) {
        if (!jsconfig_settings.oab_legal_statement && me.userData?.recognized_user) {
          signUpEmailObj.ACTION = 'unset';
        } else {
          signUpEmailObj.ACTION = '';
        }
      }
      if (jsconfig_settings.oab_legal_statement) {
        signUpEmailObj.LAST_SOURCE = 'appointment_booking';
        signUpEmailObj.ORIGINAL_SOURCE = 'appointment_booking';
        signUpEmailObj.suppress_conf_email = 1;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = 1;
        signUpEmailObj.PC_EMAIL_PROMOTIONS = oabTermsEmailPromotionsRadio;
        if (oabTermsSMSPromotionsRadio === '1') {
          signUpEmailObj.MOBILE_NUMBER =
            apptKrSelectPhoneCode.val() + '-' + phone1Input.val() + '-' + phone2Input.val();
        }
        signUpEmailObj.SMS_PROMOTIONS = oabTermsSMSPromotionsRadio;
        signUpEmailObj.POSTAL_PROMOTIONS = oabTermsPostalRadio;
        if (me.userData?.recognized_user) {
          signUpEmailObj.ACTION = 'unset';
          signUpEmailObj.PC_EMAIL_PROMOTIONS = '0';
          signUpEmailObj.SMS_PROMOTIONS = '0';
          signUpEmailObj.POSTAL_PROMOTIONS = '0';
        }
      }
      if (commercialTerms) {
        signUpEmailObj.DATA_PRIVACY_CONSENT = commercialTerms;
        signUpEmailObj.COMMERCIAL_PERMISSION = commercialTerms;
        signUpEmailObj.MOBILE_NUMBER = phone;
      }
      // avoiding _SECONDARY_SUBMIT SMS for BB TR as already passing DATA_PRIVACY_CONSENT to store email and sms promotions
      if (!commercialTerms) {
        if (!jsconfig_settings.do_not_submit_sms_pg_form) {
          if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.MOBILE_PHONE = phone;
            signUpEmailObj.SMS_PROMOTIONS = 1;
          }

          if (!signUpSMS && !ommit_sms) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.SMS_PROMOTIONS = 0;
          }
        }
      }
      var oab_params = oab.oab_params || 0;

      if (oab_params) {
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = terms;
        signUpEmailObj.OAB_EMAIL_PROMOTIONS = oab_email_promotions;
        // adding pc_email_promotion checked value as params for BB RU
        signUpEmailObj.PC_EMAIL_PROMOTIONS = $('input[name=PC_EMAIL_PROMOTIONS]:checked').val();
      }

      signUpEmailParams.push(signUpEmailObj);

      if (!is_coresite) {
        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(signUpEmailParams),
          onSuccess: function () {
            this.signUpEmailDone = true;
            doBooking();
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');

            // This error can be safely ignored. Perlgem throws the error because we are trying to "unsubscribe" a user that is already not subscribed.
            if (errObjs.length === 1 && errObjs[0].key === 'email_signup_not_subscribed') {
              doBooking();

              return;
            }

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (
                  myErr.key === 'required.pc_email_address.email_signup' ||
                  myErr.key === 'invalid.pc_email_address.email_signup'
                ) {
                  emailInput.addClass('error');
                  errorMessages.filter('#error-signup-email').css('display', 'block');
                }

                if (
                  myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms'
                ) {
                  phoneInput.addClass('error');
                  errorMessages.filter('#error-signup-sms').css('display', 'block');
                }

                if (myErr.key === 'invalid.mobile_phone.sms') {
                  phoneInput.addClass('error');
                  errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
                }
              }
            }

            if (!fNameInput.val()) {
              errorMessages.filter('#error-book-first-name').css('display', 'block');
              fNameInput.addClass('error');
            }
            if (!lNameInput.val()) {
              errorMessages.filter('#error-book-last-name').css('display', 'block');
              lNameInput.addClass('error');
            }
            if (!termsCheckbox.is(':checked')) {
              errorMessages.filter('#error-terms').css('display', 'block');
            }
            if (!privacyCheckbox.is(':checked')) {
              errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
            }
            $this.removeClass('disabled');
          }
        });
      } else {
        doBooking();
      }
    }
  };

  apptBook.AppointmentReviewConfirm.prototype.buildVirtualReview = function () {
    var hasVirtual = localStorage.getItem('virtual_oab');
    var me = this;

    if (hasVirtual === '0') {
      $('.js-review-book-virtual-location', this.container).addClass('hidden');
      $('.js-edit-location-link', this.container).removeClass('hidden');
      me.container.find('.js-review-book-location').removeClass('hidden');
      if (typeof google !== 'undefined') {
        me.buildLocationMap();
      }
      me.buildLocation();
    } else {
      $('.appointment-booking-review__details', this.container).addClass(
        'appointment-booking-review-virtual__details'
      );
      me.container
        .find('.js-appt_book_store_map_container, .js-review-book-location')
        .addClass('hidden');
      me.container.find('.js-review-book-virtual-location').removeClass('hidden');
    }
  };

  apptBook.AppointmentReviewConfirm.prototype.launchSelErrOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.off('click');
    this.selErrOverlay.click(function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'previous',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.off('click');
      me.selErrOverlay.remove();
    });
  };

  apptBook.AppointmentReviewConfirm.prototype.launchBookConflictOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.click(function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  Drupal.behaviors.apptBookReviewFormatter_V2 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var $reviewContainer = $('#review', context);
      var view = new apptBook.AppointmentReviewConfirm($reviewContainer);

      view.setModel(apptBook.sectionModel).startObserving();
    },
    attached: false
  };
})(jQuery);
